module.exports = __webpack_public_path__ + "static/media/conf-app5.0ec5012a.png";